import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";

import {
  MainHolder,
  Children,
  Body,
  StyledText,
} from "../../../../components/common/basic";

import { logEvent } from "firebase/analytics";
import analytics from "../../../../context/analytics";
import { BackButton } from "../../../../components/common";
import RewardItemCard from "../../mashupnwin/components/RewardItemCard";
import { useSpinTheWheelHome } from "../hooks";

const SpinTheWheelOrders = () => {
  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "SpinTheWheelOrders",
      firebase_screen_class: "SpinTheWheelOrders",
    }));
  }, []);

  const {
    history,
    background,
    userHistory,
    getItemFromStock,
    isOnGround,
  } = useSpinTheWheelHome();

  return (
    <>
      <MainHolder>
        <Children>
          <BackButton
            onClick={() => {
              history.push('/spin_the_wheel');
            }}
          />
          <Header>
            <div style={{ textAlign: 'center' }}>
              <StyledText size={24} style={{ fontFamily: 'MTNMedium' }} margin="0">{'Orders'}</StyledText>
            </div>
          </Header>
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '0 15px' }}>
              {
                isOnGround &&
                <>
                  <StyledText fontWeight="normal" size={13} style={{ fontFamily: 'MTNRegular' }}>Collect your rewards from an MTN representative at the event location.</StyledText>{" "}
                </>
              }
              {
                userHistory?.length > 0 ? userHistory.filter(item => item.won).map((item, index) => {
                  const { name, imageUrl } = getItemFromStock(item.itemCode) || {};
                  const { hasRedeemed } = item || {};
                  return (
                    <RewardItemCard
                      key={index}
                      onClick={() => {
                        if (!hasRedeemed) return history.push(`/spin_the_wheel/order_details?id=${item._id}`);
                      }}
                      color={background}
                      image={imageUrl}
                      name={name}
                      points={`${item?.officeLocation}${hasRedeemed ? ' (Redeemed)' : ''}` || (hasRedeemed ? 'Redeemed' : 'Prize')}
                      showStatus={true}
                      status={isOnGround || hasRedeemed ? "ready" : item.status}
                    />
                  )
                })
                  : <StyledText size={16} style={{ fontFamily: 'MTNMedium', textAlign: "center" }} margin="0">{'No Orders'}</StyledText>
              }
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default SpinTheWheelOrders;
